[
  {
    "clubId": "b1b387bf-ecee-5890-b5a4-c44f6dcdd840",
    "clubName": "Global D10 G0001 Club 04",
    "played": 0,
    "won": 0,
    "drawn": 0,
    "lost": 0,
    "goalsFor": 0,
    "goalsAgainst": 0,
    "goalDifference": 0,
    "points": 0,
    "position": 1
  },
  {
    "clubId": "c407409d-dcdf-55d7-b455-42bba20c0fc6",
    "clubName": "Global D10 G0001 Club 06",
    "played": 0,
    "won": 0,
    "drawn": 0,
    "lost": 0,
    "goalsFor": 0,
    "goalsAgainst": 0,
    "goalDifference": 0,
    "points": 0,
    "position": 2
  },
  {
    "clubId": "0dec38cf-4f50-59a3-9113-68994b1068e5",
    "clubName": "Global D10 G0001 Club 03",
    "played": 0,
    "won": 0,
    "drawn": 0,
    "lost": 0,
    "goalsFor": 0,
    "goalsAgainst": 0,
    "goalDifference": 0,
    "points": 0,
    "position": 3
  },
  {
    "clubId": "5fde2141-dbbe-501d-859f-ae12674d9a73",
    "clubName": "3u4z25foxo@test.com Club",
    "played": 0,
    "won": 0,
    "drawn": 0,
    "lost": 0,
    "goalsFor": 0,
    "goalsAgainst": 0,
    "goalDifference": 0,
    "points": 0,
    "position": 4
  },
  {
    "clubId": "7aad7836-724a-5b9c-b8f7-c267fa4f2c86",
    "clubName": "Global D10 G0001 Club 05",
    "played": 0,
    "won": 0,
    "drawn": 0,
    "lost": 0,
    "goalsFor": 0,
    "goalsAgainst": 0,
    "goalDifference": 0,
    "points": 0,
    "position": 5
  },
  {
    "clubId": "7efa5b1e-93e2-5b1f-b29c-14f6d1c9dfee",
    "clubName": "Test FC",
    "played": 0,
    "won": 0,
    "drawn": 0,
    "lost": 0,
    "goalsFor": 0,
    "goalsAgainst": 0,
    "goalDifference": 0,
    "points": 0,
    "position": 6
  }
]
